import Box from '@mui/material/Box'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { ru } from 'date-fns/locale/ru';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker'
import Alert from '@mui/material/Alert'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'
import { useTranslation } from 'react-i18next'
import { 
  toPickerValue,
} from './helpers'
import { formatDistance, startOfDay } from 'date-fns'
import Typography from '@mui/material/Typography';

const AccessPeriodInputs = ({
  value,
  onChange,
}: {
  value: string | Date | null
  onChange: (value: Date | null) => void
}) => {
  const { t } = useTranslation();
  const minDate = startOfDay(new Date())

  const handleDateChange: DatePickerProps['onChange'] = (val) => {
    if (!(val instanceof Date) || Number.isNaN(val.getTime())) {
      onChange(null)
      return
    }
    const next = new Date(val)
    next.setHours(23, 59, 59, 999)
    onChange(next)
  }

  const helperText = value ? `${t('expires')}: ${
    formatDistance(
      value instanceof Date ? value : new Date(String(value)),
      new Date(), 
      { 
        addSuffix: true, 
        locale: ru 
      })
  }` : undefined

  return (
    <>
      <Alert severity="info" sx={{ mb: 3, whiteSpace: 'pre-line' }}>
        { `${t('access_type')}: ${t('abonement')} -> ${t('choose_abonement')}.` }
      </Alert>
      <InputLabel>{t('set_period')}</InputLabel>
      <FormControl fullWidth sx={{ mb: 3 }}>
        <LocalizationProvider 
          dateAdapter={AdapterDateFns} 
          adapterLocale={ru}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              marginTop: 2,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                color: "text.secondary"
              }}
            >
              { t('to') }
            </Typography>
            <DatePicker
              value={toPickerValue(value)}
              disablePast
              minDate={minDate}
              onChange={handleDateChange}
              slotProps={{
                textField: {
                  helperText
                },
                dialog: { disableEnforceFocus: true },
              }}
            />
          </Box>
        </LocalizationProvider>
      </FormControl>
    </>
  );
}

export default AccessPeriodInputs;